import { Component, OnInit, ViewChild } from '@angular/core';
import { InternationalizationHelper } from '../helpers/InternationalizationHelper';
import { BaseComponent } from '../classes/BaseComponent';
import { Config } from '../classes/Config';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { CountryService } from '../country.service';
import { ICountryChangedListener } from '../classes/ICountryChangedListener';

@Component({
  selector: 'app-privacy-policy',
  templateUrl: './privacy-policy.component.html',
  styleUrls: ['./privacy-policy.component.scss']
})
export class PrivacyPolicyComponent extends BaseComponent implements OnInit, ICountryChangedListener {

  language: string;

  privacyPolicyURL: SafeUrl;
  
  @ViewChild("header", {static: false}) header;

  constructor(private sanitizer: DomSanitizer, private countryService: CountryService) {
    super();
    countryService.addEventListener(this);
  }
  onCountryChanged(country: any) {
    this.language = InternationalizationHelper.getTwoCharactersLanguage();
    this.privacyPolicyURL = this.sanitizer.bypassSecurityTrustResourceUrl(this.language == "de" ? Config.privacyPolicyDE : Config.privacyPolicyEN);
  }

  ngOnInit() {
    
  }

}
